import { client } from "api";
import { Creator } from "models/Checklist";

export type AdminSetFunctionCheckRequest = { id: string; state: boolean; installerId?: string };
export type AdminSetFunctionCheckResponse = {
  functionCheck: boolean;
  functionCheckBy: Creator | null;
  functionCheckAt: string | null;
  functionCheckByAdmin: boolean;
};

export const adminSetFunctionCheck = (params: AdminSetFunctionCheckRequest) =>
  client
    .post<AdminSetFunctionCheckResponse>(`/checklist/admin-set-function-check`, params)
    .then((res) => res.data);
